import { render, staticRenderFns } from "./Opportunity.vue?vue&type=template&id=07617e88&scoped=true"
import script from "./Opportunity.vue?vue&type=script&lang=js"
export * from "./Opportunity.vue?vue&type=script&lang=js"
import style0 from "./Opportunity.vue?vue&type=style&index=0&id=07617e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07617e88",
  null
  
)

export default component.exports